<template>
  <v-tooltip bottom max-width="250" :disabled="!hasConflict || isSelected">
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <v-btn
          :data-cy="`quickFilterButton-${label}`.replace(/ /g, '-')"
          :disabled="hasConflict && !isSelected"
          @click="toggleFilterList"
          class="ml-2"
          color="primary"
          small
          text
        >
          <v-icon class="mr-1" small v-if="isSelected">far fa-fw fa-check-square</v-icon>
          <v-icon class="mr-1" small v-else-if="hasConflict">fas fa-fw fa-exclamation-circle</v-icon>
          <v-icon class="mr-1" small v-else>far fa-fw fa-square</v-icon>
          {{ label }}</v-btn
        >
      </span>
    </template>
    <span
      >The quick filter "{{ label }}" conflicts with a filter that is already in use. Filters with the same field and
      operator cannot be used in conjunction with one another.</span
    >
  </v-tooltip>
</template>

<script>
import { intersectionWith, isEqual } from "lodash";

import { formatFilterList } from "../lib/formatters";

export default {
  computed: {
    hasConflict() {
      let foundConflict = false;

      this.selectedFilterList.forEach(selectedFilter => {
        this.quickFilterList.forEach(quickFilter => {
          if (
            quickFilter.operator === selectedFilter.operator &&
            quickFilter.attributeName === selectedFilter.attributeName
          ) {
            foundConflict = true;
          }
        });
      });
      return foundConflict;
    },
    isSelected() {
      if (
        intersectionWith(
          this.formatFilterList(this.selectedFilterList),
          this.formatFilterList(this.quickFilterList),
          isEqual
        ).length === this.quickFilterList.length
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    formatFilterList(filterList) {
      return formatFilterList(filterList);
    },
    toggleFilterList() {
      if (this.isSelected) {
        this.$emit("removeFilterList", this.quickFilterList);
        return;
      }
      this.$emit("addFilterList", this.quickFilterList);
    },
  },
  props: {
    label: {
      required: true,
      type: String,
    },
    quickFilterList: {
      required: true,
      type: Array,
    },
    selectedFilterList: {
      required: true,
      type: Array,
    },
  },
};
</script>
